export default {
	section_banner: {
		title: {
			one: 'リクエスト',
		},
		main_title: {
			one: '便利に',
		},
		paragraph: {
			one: '友人や家族は、非公開で、即座に、通知なしに暗号通貨をリクエストできます。',
		},
		cta_buttons: {
			one: 'Cryptocurrency Request',
			two: 'Download App',
		},
	},

	maximize_rewards_sec: {
		label: '双方向メッセージング',
		title: {
			one: '便利',
			two: '資産',
			three: 'リクエストサービス',
		},
		paragraph: {
			one: 'JPWorldPaysのリクエスト機能は便利で使いやすく、ユーザーは暗号通貨の送受信をスムーズに行うことができます。双方向のインスタントメッセージングにより、リアルタイムでコミュニケーションを取り、取引を確認できるため、プロセス全体がスムーズかつ効率的になります。',
		},
		cta_buttons: {
			one: 'ショッピングを始める',
		},
	},

	credit_system_sec: {
		label: '最速の支払いシステム',
		title: {
			one: '無料 ',
			two: 'リクエストサービス',
			three: '手間をかけずに',
		},
		paragraph: {
			one: 'JPWorldPayを使って友達に送金をリクエストしたら、あとは待つだけです。資金は自動的にあなたの口座に入金されます。この手間のかからないプロセスにより、追加の手順を必要とせず、迅速、安全、そして便利な送金が実現します。',
		},
		cta_buttons: '始めましょう',
	},
	credit_system_right_sec: {
		label: '最速の支払いシステム',
		title: {
			one: '素早い',
			two: '&',
			three: '簡単',
			four: '設定',
			five: 'プロセス',
		},
		paragraph: {
			one: 'お友達がJPWorldPayアカウントをお持ちでない場合は、サインアップするだけで数分で完了します。手続きはシンプルで迅速、すぐに送金や受け取りができるようになります。安全で便利な取引をすぐに開始できます。',
		},
		cta_buttons: 'キャッシュカード情報',
	},

	question_sec: {
		label: '給与プロセス',
		title: {
			one: '簡単です',
			two: '給料を送りますか？',
		},
		paragraph: {
			one: 'アプリを開いて「支払いを受け取る」を選択すると、QRコードが生成され、支払い情報が即座に共有されるため、他のユーザーが安全に簡単に送金できるようになります。',
		},
		cta_buttons: {
			one: '始めましょう',
		},
	},
	received_request_sec: {
		label: 'JPWorldPayユーザーを選択',
		title: {
			one: '入力 ',
			two: '要求されたもの ',
			three: '額',
		},
		paragraph: {
			one: 'JPWorldPayを通して資産リクエスト用のリンクを瞬時に作成することで、日々の暗号通貨の受け取りを簡素化できます。この合理化されたプロセスにより、迅速かつ安全に支払いを受け取り、取引の管理が容易になります。常に財務状況を把握し、シームレスな送金をお楽しみください。JPWorldPayを使えば、暗号通貨の管理はかつてないほど簡単になります。',
			two: 'JPWorldPayでは、すべての取引をリアルタイムで追跡できるため、財務活動を完全に可視化できます。送金時も受取時も、資金の所在を常に正確に把握できます。さらに、強化されたセキュリティ機能により、お客様の情報はプライバシーが保護され、あらゆる取引において安心感が得られます。JPWorldPayは詳細な取引履歴も提供しているため、過去の支払いの確認や支出の追跡も簡単です。',
		},
		cta_buttons: {
			one: 'JPWORLDPAY LINKの作成',
		},
	},

	section_newsletter: {
		label: 'ニュースレターを購読する',
		title: {
			one: '購読する',
			two: '最新情報を入手',
		},
		description: {
			one: '購読して、オファーや最新情報をメールボックスに直接受け取りましょう。',
			two: '当社の JPWorldPay ソリューションが貴社のビジネスをどのように拡大できるかについて詳しくは、お問い合わせください。',
		},
		form: {
			placeholder: 'メールID',
			button: '今すぐ購読する',
		},
	},
};
